export function getValidBoards(profileData) {
  return (
    profileData?.boards?.filter((board) => board?.board_id !== null) || []
  );
}

export function getBoardNavigationPath(board) {
  return `/board/${board?.key ?? board?.board_id}`;
}

export function isPrivateBoard(board) {
  return Boolean(board?.is_private);
}
